import { useCallback, useEffect, useState } from "react";
import { profilesApi } from "../api/endpoints/profiles";

/**
 * Loads the list of child profiles, optionally filtered server-side.
 * Pass a memoized `filters` object to avoid refetch loops.
 *
 * @param {{age?: string, gn_devision?: string, vaccination?: string, growth?: string}} [filters]
 * @param {{ archived?: boolean }} [options] — when `archived: true`, hits
 *   `/profiles/archived` instead of `/profiles`. Default: active list.
 */
export function useProfiles(filters, options = {}) {
    const { archived = false } = options;
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = archived
                ? await profilesApi.listArchived()
                : await profilesApi.list(filters || {});
            setData(result);
        } catch (e) {
            setError(e);
        } finally {
            setLoading(false);
        }
    }, [archived, filters]);

    useEffect(() => {
        load();
    }, [load]);

    return { data, loading, error, refetch: load };
}
